import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'noctem-lib',
  template: `
    <p>
      noctem-lib works!
    </p>
  `,
  styles: []
})
export class NoctemLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
